import { useParams } from "react-router-dom";
import { useLang } from "../context/LangContext";
import { useStore } from "../context/StoreContext";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

const TITLES = { shipping: "p_shipping", returns: "p_returns", privacy: "p_privacy", terms: "p_terms" };

export const FaqPage = () => {
  const { t, L } = useLang();
  const { settings } = useStore();
  return (
    <div data-testid="faq-page" className="container-q max-w-3xl pb-28 pt-16">
      <h1 className="mb-10 text-4xl sm:text-5xl">{t("faq")}</h1>
      <Accordion type="single" collapsible>
        {(settings?.faq || []).map((f, i) => (
          <AccordionItem key={i} value={`f${i}`} className="border-sand">
            <AccordionTrigger data-testid={`faq-item-${i}`} className="text-start text-base hover:no-underline">{L(f, "q")}</AccordionTrigger>
            <AccordionContent className="leading-7 text-ink/75">{L(f, "a")}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};

export default function InfoPage() {
  const { slug } = useParams();
  const { t, L } = useLang();
  const { settings } = useStore();
  return (
    <div data-testid={`info-page-${slug}`} className="container-q max-w-3xl pb-28 pt-16">
      <h1 className="mb-10 text-4xl sm:text-5xl">{t(TITLES[slug] || "p_terms")}</h1>
      <p className="whitespace-pre-line text-base leading-8 text-ink/80">{L(settings?.pages, slug)}</p>
    </div>
  );
}
